// extracted by mini-css-extract-plugin
export default {"root":"StickyLogo__root--wBfBg","logo":"StickyLogo__logo--nIrn3"};